import { createContext } from "react";
import TableTemplate from "../TableTemplate/tableTemplate";
import {
  ISahraUserGroupsReport,
  ISahraUserGroupsSearchParam,
} from "../../Interfaces/sahraUserGroupsInterfaces";
import { getsahraUserGroupTable } from "../../Requests/sahraUserGroupRequests";
import TableUI from "./TableUI";

interface IProps {
  tableRefreshFlag: boolean;
  setTableRefreshFlag: (flag: boolean) => void;
  onEdit: (row: ISahraUserGroupsReport) => void;
}

export const SahraUserGroupsTableContext = createContext({
  onEdit: (_row: ISahraUserGroupsReport) => {},
});

const SahraUserGroupsTable = ({
  tableRefreshFlag,
  setTableRefreshFlag,
  onEdit,
}: IProps) => {
  return (
    <SahraUserGroupsTableContext.Provider value={{ onEdit }}>
      <TableTemplate<ISahraUserGroupsSearchParam, ISahraUserGroupsReport>
        getDataTable={getsahraUserGroupTable}
        tableWrapperClassname="!w-fit"
        TableUI={({ reports, onAction }) => (
          <TableUI
            reports={reports}
            onAction={onAction}
            tableRefreshFlag={tableRefreshFlag}
            setTableRefreshFlag={setTableRefreshFlag}
          />
        )}
      />
    </SahraUserGroupsTableContext.Provider>
  );
};

export default SahraUserGroupsTable;
